import { h } from 'preact'
import { PureComponent } from 'preact-compat'
import axios, { AxiosResponse, CancelTokenSource } from 'axios'
import { EventHit, Hit, isCommunityResultEvent } from '../algolia/components'
import TopicListItemView, { TopicInfo } from '../topic-list-view/TopicListItemView'
import { EventListItemView } from '../event/EventListOverview'
import { common } from '../common'

interface Props {
  topics: Array<EventHit | Hit>
  isGuest: boolean
  pageCount: number
  attachmentCdn: string
  loaderCallback: (loading: boolean) => void
  clickCallback: (topicId: number, idx: number) => void
}

interface State {
  topicsList: Array<EventHit | TopicInfo>
}

const topicCache: Record<number, EventHit|TopicInfo|undefined> = {}

function isCommunityResultTopic (el: EventHit | TopicInfo | undefined): el is TopicInfo | EventHit {
  return el !== undefined && ('firstPost' in el || el.content_type === 'event')
}

export default class extends PureComponent<Props, State> {
  cancelToken?: CancelTokenSource

  constructor () {
    super()
    this.state = {
      topicsList: []
    }
  }

  async fetchMetadataForTopics () {
    this.cancelToken?.cancel()

    const topicsToFetch = this.props.topics.filter(topic => {
      return !(topic.id in topicCache) && !isCommunityResultEvent(topic)
    })

    this.cancelToken = axios.CancelToken.source()

    let result: AxiosResponse|null = null
    if (topicsToFetch.length) {
      try {
        this.props.loaderCallback(true)
        result = await axios.get('/search/getTopics', {
          params: {
            topicIds: topicsToFetch.map(topic => topic.public_id ?? topic.id)
          },
          cancelToken: this.cancelToken.token
        })
        this.props.loaderCallback(false)
      } catch {
        this.props.loaderCallback(false)
        return
      }

      if (!result || !result.data) return

      for (const hit of result.data) {
        topicCache[hit.id] = hit
      }
    }

    let joinWith: State['topicsList'] = []
    if (this.props.pageCount > 0) {
      joinWith = this.state.topicsList
    }

    this.setState({
      topicsList: joinWith.concat(this.props.topics.map(topic => {
        return isCommunityResultEvent(topic) ? topic : topicCache[topic.id]
      }).filter(isCommunityResultTopic))
    })
  }

  componentDidMount () {
    this.fetchMetadataForTopics()
  }

  componentDidUpdate (prevProps: Props) {
    if (JSON.stringify(this.props.topics) === JSON.stringify(prevProps.topics)) return
    this.fetchMetadataForTopics()
  }

  render ({ isGuest, attachmentCdn, clickCallback }: Props) {
    return (
      <div className='community-search-result'> {
      this.state.topicsList.map((topic, idx) => {
        return isCommunityResultEvent(topic)
          ? (
            <EventListItemView {...topic} startAt={topic.starts_at} endAt={topic.ends_at} destinationUrl={topic.topic_url} />
            )
          : (
            <TopicListItemView
              key={topic.id}
              clickCallback={() => clickCallback(topic.id, idx)}
              hideCategoryMetadata={(topic.type === 'ideation' ? common.isModuleActive('ideationV2') : topic.contentType === 'productUpdate')}
              topic={topic}
              isGuest={isGuest}
              attachmentCdn={attachmentCdn}
            />
            )
      })
    }</div>
    )
  }
}
